module.exports = __webpack_public_path__ + "static/media/cutting-board-header.f993338a.jpg";